/**
 * PocketFiler - English (en) Translation File
 * Base language - all keys defined here
 */

const en = {
  "nav.login": "Log in",
  "nav.signup": "Get Started",
  "nav.logout": "Log out",
  "nav.dashboard": "Dashboard",
  "nav.virtualOffices": "Virtual Offices",
  "nav.clients": "Contacts",
  "nav.contacts": "Contacts",
  "nav.deals": "Deals",
  "nav.documents": "Documents",
  "nav.messages": "Messages",
  "nav.settings": "Settings",
  "nav.companyProfile": "Company Profile",
  "nav.products": "Products",
  "nav.directory": "Directory",
  "nav.invoices": "Invoices",
  "nav.templates": "Templates",
  "nav.tasks": "Tasks",
  "nav.meetings": "Meetings",
  "nav.analytics": "Analytics",
  "nav.rfq": "RFQ",
  "nav.developerSettings": "API Keys & Webhooks",
  "nav.events": "Events",
  "landing.badge": "AI-Powered Deal Platform",
  "landing.hero.title": "Need a Contract?",
  "landing.hero.titleHighlight": "AI Writes It.",
  "landing.hero.subtitle": "Smart AI contracts, intelligent document workflows, and real AI translation for texts, video calls, and contracts—built for professional services and global trade.",
  "landing.hero.cta.start": "Start For Free",
  "landing.hero.cta.demo": "See How It Works",
  "landing.hero.trust": "Free plan. No credit card required. 11 languages supported.",
  "landing.socialProof": "Trusted by 500+ businesses in 40 countries",
  "landing.useCases.title": "Built for Cross-Language, High-Trust Transactions",
  "landing.useCases.subtitle": "",
  "landing.useCases.professional.title": "Professional Services",
  "landing.useCases.professional.subtitle": "Insurance, Real Estate, Lending",
  "landing.useCases.professional.desc": "Invite clients to upload documents with AI assistance, track every interaction in Secured Virtual Offices, and generate bilingual digital contracts—all from one workspace.",
  "landing.useCases.globalTrade.title": "Global Trade & Cross-Border Commerce",
  "landing.useCases.globalTrade.desc": "Source overseas suppliers with no language barriers and no expensive trade shows. Manage compliance documents in dedicated Deal Rooms with real-time translation.",
  "landing.useCases.personal.title": "High-Value Personal Transactions",
  "landing.useCases.personal.desc": "Close important one-off deals like vehicles, equipment, or property with clear records, AI contracts, and simple secure links for document sharing.",
  "landing.howItWorks.title": "How PocketFiler Works for Any Deal",
  "landing.howItWorks.subtitle": "",
  "landing.howItWorks.dealRooms.title": "Deal Rooms & Contracts",
  "landing.howItWorks.dealRooms.desc": "Every deal gets a dedicated Room with a timeline, messages, documents, and AI-generated contract drafts you can review and finalize.",
  "landing.howItWorks.translation.title": "Auto AI Translation",
  "landing.howItWorks.translation.desc": "Messages and key content are translated instantly between parties, so buyers, sellers, and clients can communicate in their own language.",
  "landing.howItWorks.documents.title": "Smart Documents",
  "landing.howItWorks.documents.desc": "Clients upload documents from their phone; AI extracts key fields, checks quality, and flags issues before they slow down a deal.",
  "landing.howItWorks.concierge.title": "AI Concierge",
  "landing.howItWorks.concierge.desc": "Your AI assistant learns your business, sets up the right Virtual Offices, and configures document checklists for each type of deal.",
  "landing.cta.title": "Start Closing Cross-Language Deals Today",
  "landing.cta.subtitle": "Join businesses handling high-stakes deals in 11 languages",
  "landing.cta.button": "Create Free Account",
  "landing.cta.secondary": "See a Sample Deal Room",
  "landing.footer.tagline": "Important deals made simple.",
  "language.picker.title": "Choose your language",
  "language.picker.subtitle": "We'll show all instructions, messages, and contracts in this language. Other people can choose their own language; AI will handle the translation for you.",
  "language.picker.continue": "Continue",
  "language.picker.playSample": "Play sample",
  "language.picker.playing": "Playing...",
  "language.picker.confirmation": "You selected {language}. We'll show you everything in this language. Other parties can choose their own language; PocketFiler translates messages, documents, and contracts so everyone understands.",
  "language.toast.saved": "Language saved! To change it, go to Settings in your profile.",
  "language.confirm.title": "Confirm Your Language",
  "language.confirm.subtitle": "This language will be used for all UI, messages, and contracts.",
  "language.confirm.change": "Change Language",
  "language.confirm.continue": "Continue with",
  "language.confirm.chineseNote": "Note: You selected Simplified Chinese (简体中文). If you prefer Traditional Chinese, please change your selection.",
  "auth.login.title": "Welcome back",
  "auth.login.subtitle": "Sign in to your PocketFiler account",
  "auth.login.email": "Email",
  "auth.login.password": "Password",
  "auth.login.submit": "Sign in",
  "auth.login.noAccount": "Don't have an account?",
  "auth.login.signupLink": "Sign up",
  "auth.login.error": "Invalid email or password",
  "auth.signup.title": "Create your account",
  "auth.signup.subtitle": "Start closing deals in any language",
  "auth.signup.name": "Full Name",
  "auth.signup.email": "Email",
  "auth.signup.password": "Password",
  "auth.signup.confirmPassword": "Confirm Password",
  "auth.signup.companyName": "Company Name",
  "auth.signup.companyType": "Account Type",
  "auth.signup.accountType": "Account Type",
  "auth.signup.submit": "Create Account",
  "auth.signup.hasAccount": "Already have an account?",
  "auth.signup.loginLink": "Log in",
  "auth.signup.terms": "By signing up, you agree to our Terms of Service and Privacy Policy.",
  "auth.signup.passwordsDoNotMatch": "Passwords do not match",
  "auth.signup.passwordTooShort": "Password must be at least 8 characters",
  "auth.signup.success": "Account created successfully!",
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Welcome back, {name}",
  "dashboard.aiSummary.title": "AI Summary",
  "dashboard.aiSummary.generating": "Generating summary...",
  "dashboard.stats.totalDeals": "Total Deals",
  "dashboard.stats.activeDeals": "Active Deals",
  "dashboard.stats.totalClients": "Total Contacts",
  "dashboard.stats.totalContacts": "Total Contacts",
  "dashboard.stats.documentsProcessed": "Documents Processed",
  "dashboard.recentDeals.title": "Recent Deals",
  "dashboard.recentDeals.viewAll": "View all",
  "dashboard.recentDeals.empty": "No deals yet. Create your first deal to get started.",
  "dashboard.recentClients.title": "Recent Contacts",
  "dashboard.recentContacts.title": "Recent Contacts",
  "dashboard.recentClients.viewAll": "View all",
  "dashboard.recentContacts.viewAll": "View all",
  "dashboard.recentClients.empty": "No contacts yet. Invite your first contact to get started.",
  "dashboard.recentContacts.empty": "No contacts yet. Invite your first contact to get started.",
  "dashboard.quickActions.title": "Quick Actions",
  "dashboard.quickActions.createDeal": "Create Deal",
  "dashboard.quickActions.inviteClient": "Add Contact",
  "dashboard.quickActions.inviteContact": "Add Contact",
  "dashboard.quickActions.createOffice": "Create Virtual Office",
  "offices.title": "Virtual Offices",
  "offices.subtitle": "Organize your business by service type",
  "offices.create": "Create Virtual Office",
  "offices.empty.title": "No Virtual Offices yet",
  "offices.empty.desc": "Create your first Virtual Office to organize your deals and contacts.",
  "offices.card.clients": "{count} contacts",
  "offices.card.contacts": "{count} contacts",
  "offices.card.deals": "{count} deals",
  "offices.card.checklist": "Checklist items",
  "offices.checklist": "Document Checklist",
  "offices.noChecklist": "No documents required",
  "offices.dialog.title": "Create Virtual Office",
  "offices.dialog.desc": "Set up a new workspace for a specific service type",
  "offices.dialog.name": "Office Name",
  "offices.dialog.namePlaceholder": "e.g., Insurance Claims, Real Estate Sales",
  "offices.dialog.type": "Office Type",
  "offices.dialog.description": "Description",
  "offices.dialog.descriptionPlaceholder": "Describe what this office handles...",
  "offices.dialog.checklist": "Document Checklist",
  "offices.dialog.checklistHelp": "AI-generated checklist for required documents",
  "offices.dialog.addItem": "Add Item",
  "offices.dialog.generateChecklist": "Generate with AI",
  "offices.dialog.creating": "Creating...",
  "offices.dialog.create": "Create Office",
  "offices.form.name": "Office Name",
  "offices.form.namePlaceholder": "e.g., Insurance Services, Real Estate, etc.",
  "offices.form.description": "Description",
  "offices.form.descPlaceholder": "What type of deals will this office handle?",
  "offices.form.checklistPlaceholder": "Add required document...",
  "offices.ai.title": "AI-Assisted Setup",
  "offices.ai.desc": "Let our AI Concierge help you set up the perfect virtual office by asking about your business needs.",
  "offices.ai.manual": "Set Up Manually",
  "offices.ai.start": "Start AI Setup",
  "offices.ai.startOnboarding": "Help me set up my virtual office",
  "offices.ai.suggestion": "AI Suggestion",
  "offices.ai.acceptSuggestion": "Accept & Create Office",
  "offices.ai.inputPlaceholder": "Type your response...",
  "clients.title": "Contacts",
  "contacts.title": "Contacts",
  "clients.subtitle": "Manage your contacts and invitations",
  "contacts.subtitle": "Manage your contacts and invitations",
  "clients.invite": "Add Contact",
  "contacts.invite": "Add Contact",
  "clients.empty.title": "No contacts yet",
  "contacts.empty.title": "No contacts yet",
  "clients.empty.desc": "Add your first contact to get started.",
  "contacts.empty.desc": "Add your first contact to get started.",
  "clients.table.name": "Name",
  "clients.table.client": "Contact",
  "contacts.table.contact": "Contact",
  "clients.table.contact": "Contact",
  "clients.table.office": "Office",
  "clients.table.language": "Language",
  "clients.table.status": "Status",
  "clients.table.actions": "Actions",
  "clients.status.invited": "Invited",
  "clients.status.active": "Active",
  "clients.status.completed": "Completed",
  "clients.dialog.title": "Add New Contact",
  "contacts.dialog.title": "Add New Contact",
  "clients.dialog.name": "Contact Name",
  "contacts.dialog.name": "Contact Name",
  "clients.dialog.email": "Email Address",
  "clients.dialog.phone": "Phone Number",
  "clients.dialog.office": "Virtual Office",
  "clients.dialog.language": "Preferred Language",
  "clients.dialog.sending": "Sending invitation...",
  "clients.dialog.send": "Send Invitation",
  "clients.toast.invited": "Contact added: {name}",
  "contacts.toast.invited": "Contact added: {name}",
  "clients.toast.deleted": "Contact deleted",
  "contacts.toast.deleted": "Contact deleted",
  "clients.toast.linkCopied": "Link copied to clipboard",
  "contacts.toast.linkCopied": "Link copied to clipboard",
  "clients.invite.step1Title": "Add New Contact",
  "contacts.invite.step1Title": "Add New Contact",
  "clients.invite.step2Title": "Preview Invite Message",
  "clients.invite.step3Title": "Invite Sent!",
  "clients.invite.step1Desc": "Enter contact information",
  "contacts.invite.step1Desc": "Enter contact information",
  "clients.invite.step2Desc": "Review and customize the invite message",
  "clients.invite.step3Desc": "Share the invite link with your client",
  "clients.invite.nameLabel": "Contact Name",
  "contacts.invite.nameLabel": "Contact Name",
  "clients.invite.namePlaceholder": "e.g., John Smith",
  "clients.invite.contactMethod": "Contact Method",
  "clients.invite.phone": "Phone Number",
  "clients.invite.customNote": "Custom Note",
  "clients.invite.customNotePlaceholder": "Any special notes about this contact...",
  "contacts.invite.customNotePlaceholder": "Any special notes about this contact...",
  "clients.invite.previewMessage": "Preview Message",
  "clients.invite.aiGenerated": "AI-generated invite message",
  "clients.invite.messagePreview": "Message Preview",
  "clients.invite.messageEditHint": "You can edit this message before sending",
  "clients.invite.documentsRequested": "Documents requested",
  "clients.invite.regenerate": "Re-generate message",
  "clients.invite.sendInvite": "Send Invite",
  "clients.invite.linkCreated": "Invite Link Created!",
  "clients.invite.linkCopiedToClipboard": "The link has been copied to your clipboard",
  "clients.invite.shareLink": "Share this link with your contact via email, SMS, or in person",
  "contacts.invite.shareLink": "Share this link with your contact via email, SMS, or in person",
  "clients.invite.inviteAnother": "Invite Another",
  "clients.invite.success": "Client invited!",
  "clients.invite.linkCopied": "Invite link copied!",
  "clients.invite.yourAgent": "Your agent",
  "clients.invite.defaultOffice": "Our Office",
  "clients.nav.myClients": "My Clients",
  "clients.nav.joinedOrgs": "Joined Organizations",
  "clients.table.organization": "Organization",
  "clients.table.joinedDate": "Joined Date",
  "clients.joined.empty.title": "No Organizations Joined",
  "clients.joined.empty.desc": "You haven't joined any organizations yet. Ask them to invite you to their PocketFiler workspace.",
  "contacts.actions.title": "Contact {name}",
  "contacts.actions.call": "Call",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.actions.sms": "Text Message",
  "contacts.actions.email": "Email",
  "contacts.actions.message": "Send In-App Message",
  "contacts.actions.noPhone": "No phone number",
  "contacts.actions.noEmail": "No email address",
  "deals.title": "Deals",
  "deals.subtitle": "Manage your active and completed deals.",
  "deals.tabs.all": "All Deals",
  "deals.tabs.my": "My Deals",
  "deals.create": "Create Deal",
  "deals.empty.title": "No deals yet",
  "deals.empty.desc": "Create your first deal to get started.",
  "deals.search": "Search deals...",
  "deals.validation.titleRequired": "Deal title is required",
  "deals.validation.titleLength": "Title must be 100 characters or less",
  "deals.validation.clientRequired": "Please select at least one client",
  "deals.validation.notesLength": "Notes must be 200 characters or less",
  "deals.filter.all": "All Deals",
  "deals.filter.active": "Active",
  "deals.filter.pending": "Pending",
  "deals.filter.closed": "Closed",
  "deals.column.draft": "Draft",
  "deals.column.active": "Active",
  "deals.column.pending": "Pending",
  "deals.column.pending_documents": "Pending Documents",
  "deals.column.pending_signature": "Pending Signature",
  "deals.column.pending_payment": "Pending Payment",
  "deals.column.escrow_funded": "Escrow Funded",
  "deals.column.release_requested": "Release Requested",
  "deals.column.disputed": "Disputed",
  "deals.column.on_hold": "On Hold",
  "deals.column.completed": "Completed",
  "deals.column.cancelled": "Cancelled",
  "deals.column.closed": "Closed",
  "deals.card.documents": "{count} documents",
  "deals.card.messages": "{count} messages",
  "deals.dialog.title": "Create New Deal",
  "deals.dialog.dealTitle": "Deal Title",
  "deals.dialog.dealTitlePlaceholder": "e.g., Vehicle Purchase - Honda Civic 2023",
  "deals.dialog.client": "Client",
  "deals.dialog.office": "Virtual Office",
  "deals.dialog.type": "Deal Type",
  "deals.dialog.notes": "Notes",
  "deals.dialog.notesPlaceholder": "Add any notes about this deal...",
  "deals.dialog.creating": "Creating...",
  "deals.dialog.create": "Create Deal",
  "dealRoom.back": "Back to Deals",
  "dealRoom.readOnly.title": "Read-only",
  "dealRoom.readOnly.closedMessage": "This deal has been closed. The Deal Room is now read-only for reference and audit purposes.",
  "dealRoom.readOnly.cancelledMessage": "This deal has been cancelled. The Deal Room is now read-only for reference and audit purposes.",
  "dealRoom.readOnly.completedMessage": "This deal has been completed successfully. The Deal Room is now read-only for reference and audit purposes.",
  "dealRoom.tabs.messages": "Messages",
  "dealRoom.tabs.documents": "Documents",
  "dealRoom.tabs.contract": "Contract",
  "dealRoom.timeline.title": "Activity Timeline",
  "dealRoom.timeline.empty": "No activity recorded yet.",
  "dealRoom.timeline.createdBy": "by {name}",
  "dealRoom.details.title": "Deal Details",
  "dealRoom.details.clients": "Clients",
  "dealRoom.details.notes": "Notes",
  "dealRoom.details.type": "Type",
  "dealRoom.details.documents": "Documents",
  "dealRoom.details.messages": "Messages",
  "dealRoom.aiSummary.title": "AI Summary",
  "dealRoom.aiSummary.generating": "Generating summary...",
  "dealRoom.messages.empty": "No messages yet. Start the conversation.",
  "dealRoom.messages.placeholder": "Type a message...",
  "dealRoom.messages.send": "Send",
  "dealRoom.messages.sending": "Sending...",
  "dealRoom.messages.showOriginal": "Show original",
  "dealRoom.messages.showTranslation": "Show translation",
  "dealRoom.messages.translatedFrom": "Translated from {language}",
  "dealRoom.messages.suggestReply": "Suggest Reply",
  "dealRoom.documents.empty": "No documents uploaded yet.",
  "dealRoom.documents.upload": "Upload Document",
  "dealRoom.documents.uploading": "Uploading...",
  "dealRoom.documents.analyze": "Analyze",
  "dealRoom.documents.analyzing": "Analyzing...",
  "dealRoom.documents.download": "Download",
  "dealRoom.documents.delete": "Delete",
  "dealRoom.documents.pending": "Pending Analysis",
  "dealRoom.documents.analyzed": "Analyzed",
  "dealRoom.documents.aiAnalysis": "AI Document Analysis",
  "dealRoom.documents.type": "Document Type",
  "dealRoom.documents.confidence": "Confidence",
  "dealRoom.documents.summary": "Summary",
  "dealRoom.documents.issues": "Issues",
  "dealRoom.contract.empty.title": "No contract generated yet",
  "dealRoom.contract.empty.desc": "Generate an AI contract draft for this deal.",
  "dealRoom.contract.generate": "Generate Contract Draft",
  "dealRoom.contract.regenerate": "Regenerate Contract",
  "dealRoom.contract.generating": "Generating...",
  "dealRoom.contract.aiLabel": "AI-generated contract draft",
  "dealRoom.contract.language": "Language",
  "dealRoom.contract.copy": "Copy",
  "dealRoom.contract.copied": "Copied to clipboard",
  "dealRoom.contract.type": "Contract Type",
  "dealRoom.contract.generated": "Generated",
  "dealRoom.contract.languages": "Languages",
  "dealRoom.contract.status": "Status",
  "dealRoom.contract.notice": "AI document analysis: One or more clauses do not have a direct equivalent between your selected languages. We have used descriptive language instead. Please review these sections carefully and confirm with the other party if needed.",
  "dealRoom.contract.analysisWarning": "Some documents haven't been analyzed yet. AI analysis improves contract accuracy.",
  "dealRoom.contract.dialog.title": "Generate Contract Draft",
  "dealRoom.contract.dialog.desc": "AI will generate a bilingual contract based on the deal details.",
  "dealRoom.contract.dialog.disclaimer": "This is an AI-generated draft for review purposes. Have a legal professional review before signing.",
  "dealRoom.contract.dialog.type": "Contract Type",
  "dealRoom.contract.dialog.languages": "Languages",
  "dealRoom.contract.dialog.languagesHelp": "Select two languages for your bilingual contract. All Tier 1 languages are fully supported.",
  "dealRoom.contract.dialog.primary": "Primary",
  "dealRoom.contract.dialog.secondary": "Secondary",
  "dealRoom.contract.dialog.terms": "Special Terms",
  "dealRoom.contract.dialog.termsPlaceholder": "Add any special terms or conditions...",
  "dealRoom.contract.dialog.generate": "Generate Contract",
  "dealRoom.contract.dialog.generating": "Generating...",
  "dealRoom.status.change": "Change Status",
  "dealRoom.status.dialog.title": "Change Deal Status",
  "dealRoom.status.dialog.from": "From",
  "dealRoom.status.dialog.to": "To",
  "dealRoom.status.dialog.reason": "Reason (optional)",
  "dealRoom.status.dialog.reasonPlaceholder": "Why are you changing the status?",
  "dealRoom.status.dialog.confirm": "Confirm Change",
  "dealRoom.status.dialog.changing": "Changing...",
  "dealRoom.status.toast.changed": "Status changed to {status}",
  "dealRoom.upgrade.title": "Upgrade to Business",
  "dealRoom.upgrade.desc": "Contract generation requires a Business plan.",
  "dealRoom.upgrade.features": "With Business, you get:",
  "dealRoom.upgrade.feature1": "AI-generated contract drafts",
  "dealRoom.upgrade.feature2": "Advanced document analysis",
  "dealRoom.upgrade.feature3": "Priority support",
  "dealRoom.upgrade.button": "Upgrade Now",
  "settings.title": "Settings",
  "settings.subtitle": "Manage your account and organization",
  "settings.tabs.profile": "Profile",
  "settings.tabs.organization": "Organization",
  "settings.tabs.sharing": "Share QR",
  "settings.profile.title": "Profile Settings",
  "settings.profile.subtitle": "Manage your personal information",
  "settings.profile.name": "Full Name",
  "settings.profile.email": "Email",
  "settings.profile.emailNote": "Email cannot be changed",
  "settings.profile.accountType": "Account Type",
  "settings.profile.accountTypeHelp": "Choose the type that best describes you",
  "settings.profile.language": "Preferred Language",
  "settings.profile.languageHelp": "All UI, messages, and contracts will be displayed in this language.",
  "settings.profile.save": "Save Changes",
  "settings.profile.saving": "Saving...",
  "settings.profile.saved": "Profile updated",
  "settings.org.title": "Organization Settings",
  "settings.org.subtitle": "Manage your business information",
  "settings.org.name": "Organization Name",
  "settings.org.type": "Industry Type",
  "settings.org.billingEmail": "Billing Email",
  "settings.org.plan": "Plan",
  "settings.org.verification": "Verification Status",
  "settings.org.save": "Save Changes",
  "settings.org.saving": "Saving...",
  "settings.org.saved": "Organization updated",
  "settings.org.noOrg": "No organization found",
  "qr.title": "Share your PocketFiler QR",
  "qr.description": "Show this code to clients or partners. When they scan it, they can connect with you and start a deal in seconds.",
  "qr.generate": "Generate QR Code",
  "qr.regenerated": "QR code regenerated. Old links are now invalid.",
  "qr.linkCopied": "Link copied to clipboard",
  "qr.copyLink": "Copy Link",
  "qr.copied": "Copied!",
  "qr.share": "Share",
  "qr.download": "Download",
  "qr.regenerate": "Reset",
  "qr.yourLink": "Your connect link:",
  "qr.clickToExpand": "Click to view full screen",
  "qr.scanToConnect": "Scan to Connect",
  "qr.scanInstructions": "Scan this QR with PocketFiler or any QR scanner to connect.",
  "qr.primaryLanguage": "Primary language",
  "support.title": "AI Support",
  "support.subtitle": "Ask anything about PocketFiler",
  "support.askAI": "Ask AI",
  "support.openChat": "Open AI support",
  "support.welcome": "Hi! I'm the PocketFiler AI assistant. I can help you with:\n\n- Creating and managing deals\n- Sending documents for signature\n- Using the QR connect feature\n- Inviting clients\n- Any other questions about PocketFiler\n\nHow can I help you today?",
  "support.inputPlaceholder": "Type your question...",
  "support.clearChat": "Clear chat",
  "support.error": "Failed to send message. Please try again.",
  "support.scheduleCall": "Schedule a call with support",
  "support.scheduleTitle": "Schedule a Support Call",
  "support.yourTimezone": "Your timezone",
  "support.availableTimes": "Available times",
  "support.inYourTime": "in your local time",
  "support.slotsError": "Failed to load available times.",
  "support.booked": "Call scheduled successfully!",
  "support.bookingError": "Failed to book slot. Please try again.",
  "support.bookingConfirmed": "Great, I've scheduled your call for {time}. You'll receive a confirmation with the call link. Is there anything else I can help with?",
  "livekit.joinCall": "Join call",
  "livekit.call": "Call",
  "livekit.inCall": "In Call",
  "livekit.leaveCall": "Leave call",
  "livekit.participant": "participant",
  "livekit.participants": "participants",
  "livekit.connecting": "Connecting...",
  "livekit.error.connect": "Failed to connect to call. Please try again.",
  "livekit.error.connection": "Connection error. Please check your network and try again.",
  "livekit.error.permission": "You don't have permission to join this call.",
  "livekit.hint": "Talk inside this Deal instead of switching apps.",
  "captions.on": "Captions On",
  "captions.off": "Captions Off",
  "captions.enable": "Enable Captions",
  "captions.disable": "Disable Captions",
  "captions.language": "Caption Language",
  "captions.live": "Live",
  "captions.connecting": "Connecting...",
  "captions.error.toggle": "Failed to toggle captions",
  "captions.error.connect": "Failed to connect to caption service",
  "captions.translating": "Translating...",
  "captions.original": "Original",
  "captions.translated": "Translated",
  "recording.start": "Record",
  "recording.stop": "Stop",
  "recording.started": "Recording started",
  "recording.stopped": "Recording stopped. Processing...",
  "recording.processing": "Processing...",
  "recording.completed": "Recording completed",
  "recording.failed": "Recording failed",
  "recording.play": "Play",
  "recording.download": "Download",
  "recording.delete": "Delete",
  "recording.confirmDelete": "Delete this recording?",
  "recording.deleted": "Recording deleted",
  "recording.noRecordings": "No recordings yet",
  "recording.playback": "Recording Playback",
  "recording.viewRecordings": "View Recordings",
  "recording.error.start": "Failed to start recording",
  "recording.error.stop": "Failed to stop recording",
  "recording.error.delete": "Failed to delete recording",
  "recording.error.noCall": "No active call. Please join the call first.",
  "schedule.button": "Schedule",
  "schedule.title": "Schedule call or recording",
  "schedule.description": "Pick a date and time. You can join the call when it's time.",
  "schedule.type": "Type",
  "schedule.typeCall": "Call",
  "schedule.typeRecording": "Recording",
  "schedule.dateTime": "Date & time",
  "schedule.create": "Schedule",
  "schedule.created": "Scheduled",
  "schedule.upcoming": "Upcoming scheduled",
  "schedule.cancel": "Cancel",
  "schedule.chooseDateTime": "Please choose date and time",
  "connect.typePerson": "Person",
  "connect.typeOrg": "Organization",
  "connect.titleAuth": "You're connecting with",
  "connect.titleUnauth": "Connect with",
  "connect.infoUnauth": "This person uses PocketFiler to manage cross-language deals and documents securely.",
  "connect.startDeal": "Start a Deal",
  "connect.joinOffice": "Join Virtual Office",
  "connect.loggedInAs": "Logged in as",
  "connect.createAccount": "Create Free Account",
  "connect.login": "Log In",
  "connect.dealCreated": "Deal created successfully",
  "connect.error.invalid": "Invalid Connect Link",
  "connect.error.invalidDesc": "This connect link is invalid or has expired.",
  "connect.error.server": "Something went wrong",
  "connect.error.serverDesc": "Please try again later.",
  "common.backToHome": "Back to Home",
  "invite.language.title": "Choose your language",
  "invite.language.subtitle": "We'll show all instructions in your language.",
  "invite.welcome.title": "Welcome to",
  "invite.welcome.subtitle": "We are ready to receive your documents.",
  "invite.welcome.time": "5-10 minutes",
  "invite.welcome.timeLabel": "Estimated time",
  "invite.welcome.secure": "Secure and Free",
  "invite.welcome.secureDesc": "Your documents are encrypted. This service is free for you.",
  "invite.welcome.start": "Start Upload",
  "invite.documents.needed": "Documents needed",
  "invite.upload.title": "Upload Document",
  "invite.upload.dragDrop": "Drag and drop a file here, or click to select",
  "invite.upload.or": "or",
  "invite.upload.takePhoto": "Images",
  "invite.upload.browse": "Files",
  "invite.upload.uploading": "Uploading...",
  "invite.upload.analyzing": "Checking document...",
  "invite.upload.success": "Uploaded successfully",
  "invite.upload.next": "Next Document",
  "invite.upload.finish": "Review All",
  "invite.upload.skip": "Skip for now",
  "invite.upload.progress": "Progress",
  "invite.complete.title": "All Done!",
  "invite.complete.subtitle": "Your documents have been submitted successfully.",
  "invite.complete.message": "We have received all your documents. You will be contacted soon.",
  "invite.complete.summary": "Documents submitted",
  "invite.complete.securityNote": "Your documents are stored securely and will only be accessed by authorized personnel.",
  "invite.chat.title": "Chat with your agent",
  "invite.chat.placeholder": "Type a message...",
  "invite.chat.empty": "No messages yet. Start a conversation.",
  "invite.chat.sent": "Your message has been sent.",
  "invite.chat.willRespond": "We will respond as soon as possible.",
  "invite.chat.sending": "Sending...",
  "invite.error.title": "Invalid or Expired Link",
  "invite.error.message": "This invite link is no longer valid. Please contact the sender for a new link.",
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.close": "Close",
  "common.dismiss": "Dismiss",
  "common.confirm": "Confirm",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.of": "of",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.sort": "Sort",
  "common.viewAll": "View all",
  "common.refresh": "Refresh",
  "common.retry": "Retry",
  "common.noResults": "No results found",
  "common.yes": "Yes",
  "common.no": "No",
  "common.or": "or",
  "common.and": "and",
  "common.optional": "optional",
  "common.required": "required",
  "status.draft": "Draft",
  "status.active": "Active",
  "status.pending": "Pending",
  "status.pending_documents": "Pending Documents",
  "status.pending_signature": "Pending Signature",
  "status.on_hold": "On Hold",
  "status.closed": "Closed",
  "status.cancelled": "Cancelled",
  "pwa.installApp": "Install App",
  "pwa.iosHint": "Tap the Share icon and \"Add to Home Screen\" to install PocketFiler.",
  "pwa.installed": "App installed successfully!",
  "pwa.banner.title": "Get the PocketFiler App",
  "pwa.banner.subtitle": "Faster access, works offline",
  "pwa.banner.install": "Install",
  "pwa.ios.title": "Install PocketFiler",
  "pwa.ios.description": "Add PocketFiler to your home screen for the best experience:",
  "pwa.ios.step1": "Tap the",
  "pwa.ios.shareButton": "Share button",
  "pwa.ios.inToolbar": "in your browser toolbar",
  "pwa.ios.step2": "Scroll down and tap",
  "pwa.ios.step3": "Tap",
  "pwa.ios.inTopRight": "in the top right corner",
  "pwa.ios.gotIt": "Got it",
  "pwa.opera.title": "Not available in Opera",
  "pwa.opera.desktopNotSupported": "Opera desktop does not support PWA installation. To install PocketFiler as an app, please open it in Google Chrome or Microsoft Edge.",
  "pwa.opera.recommendedBrowsers": "Use instead:",
  "pwa.opera.chromeHint": "open this page, then click the install icon in the address bar",
  "pwa.opera.edgeHint": "open this page, then click the install icon (⊕) in the address bar",
  "pwa.opera.mobileTitle": "Install PocketFiler in Opera",
  "pwa.opera.mobileDescription": "Tap the + icon at the bottom of Opera, or use the menu below:",
  "pwa.opera.mobileStep1": "Tap the",
  "pwa.opera.mobileStep1b": "plus (+) icon in the bottom bar of Opera",
  "pwa.opera.mobileStep2": "Or tap",
  "pwa.opera.mobileAddPage": "Add page to",
  "pwa.opera.mobileHomeScreen": "Home screen",
  "pwa.firefox.hint": "In Firefox, look for the install icon (⊕) in the address bar to add this app to your desktop.",
  "error.generic": "Something went wrong. Please try again.",
  "error.network": "Network error. Please check your connection.",
  "error.unauthorized": "You are not authorized to perform this action.",
  "error.notFound": "The requested resource was not found.",
  "error.validation": "Please check your input and try again.",
  "error.serverError": "Server error. Please try again later.",
  "success.saved": "Changes saved successfully.",
  "success.created": "Created successfully.",
  "success.deleted": "Deleted successfully.",
  "success.sent": "Sent successfully.",
  "success.uploaded": "Uploaded successfully.",
  "time.justNow": "Just now",
  "time.minutesAgo": "{count} minutes ago",
  "time.hoursAgo": "{count} hours ago",
  "time.daysAgo": "{count} days ago",
  "time.today": "Today",
  "time.yesterday": "Yesterday",
  "dealRoom.notFound": "Deal not found",
  "dealRoom.loading": "Loading deal...",
  "dealRoom.conversation.title": "Deal Conversation",
  "dealRoom.conversation.you": "You",
  "dealRoom.conversation.client": "Client",
  "dealRoom.conversation.colleague": "Colleague",
  "dealRoom.messages.hideOriginal": "Hide original",
  "dealRoom.messages.original": "Original ({language})",
  "dealRoom.messages.disabled": "Messaging is disabled for this deal status",
  "dealRoom.messages.connecting": "Connecting to chat...",
  "dealRoom.messages.connectionError": "Unable to connect to conversation.",
  "dealRoom.messages.aiSuggest": "AI suggested reply",
  "messages.readAloud.title": "Read aloud",
  "messages.readAloud.error": "Read aloud failed",
  "dealRoom.documents.title": "Documents",
  "dealRoom.documents.uploadDisabled": "Upload Disabled",
  "dealRoom.documents.pendingAnalysis": "Pending Analysis",
  "dealRoom.documents.uploadFirst": "Upload First Document",
  "dealRoom.documents.uploadHelp": "Upload documents to this deal for AI analysis",
  "dealRoom.documents.uploadDisabledHelp": "Document uploads are disabled for this deal status",
  "dealRoom.documents.analyzeWithAI": "Analyze with AI",
  "dealRoom.documents.notAnalyzed": "Not analyzed yet",
  "dealRoom.documents.notAnalyzedHelp": "Run AI analysis to extract document type, fields, and get insights",
  "dealRoom.documents.analyzeDocument": "Analyze Document",
  "dealRoom.documents.extractedFields": "Extracted Fields",
  "dealRoom.documents.issuesDetected": "Issues Detected",
  "dealRoom.documents.preview": "Preview",
  "dealRoom.documents.previewNotAvailable": "Preview not available. Downloading...",
  "dealRoom.documents.uploaded": "Uploaded",
  "dealRoom.documents.deleteConfirm": "Are you sure you want to delete this document?",
  "documents.readAloud.title": "Read aloud",
  "documents.readAloud.analyzeFirst": "Analyze this document first to read it aloud.",
  "documents.readAloud.error": "Read aloud failed",
  "dealRoom.onHold.message": "This deal is on hold. Document uploads are disabled. You can still send messages for coordination.",
  "dealRoom.pendingSignature.loading": "Loading signature status...",
  "dealRoom.pendingSignature.message": "Contract is ready for signature. Document uploads are disabled until the contract is signed or reverted.",
  "dealRoom.pendingSignature.signedWaitingOthers": "Signed successfully. Waiting for other participants.",
  "dealRoom.signedByAll.message": "Signed by all participants. Proceed to Payment.",
  "dealRoom.signedByAll.addPayment": "Add Payment",
  "dealRoom.signature.signed": "Signed",
  "dealRoom.signature.signedByYou": "Signed by you",
  "dealRoom.signature.success": "Contract signed successfully!",
  "dealRoom.signaturesList.title": "Signatures",
  "dealRoom.signaturesList.dealOwner": "Deal owner",
  "dealRoom.signaturesList.clients": "Clients",
  "dealRoom.signaturesList.pending": "Pending",
  "dealRoom.signaturesList.signedOn": "Signed on",
  "dealRoom.signaturesList.viewSignatures": "View signatures",
  "dealRoom.status.current": "current",
  "dealRoom.status.finalWarning": "This is a final state. The deal cannot be reopened after this action.",
  "dealRoom.contract.purchaseAgreement": "Purchase Agreement",
  "dealRoom.contract.purchaseAgreementDesc": "Standard purchase agreement contract",
  "dealRoom.contract.noContract": "No Contract Yet",
  "dealRoom.contract.noContractDesc": "Generate an AI-powered contract draft based on your deal details and documents.",
  "dealRoom.contract.notAvailable": "Contract generation is not available for {status} deals.",
  "dealRoom.contract.locked": "Contract generation is locked while awaiting signature.",
  "dealRoom.contract.requiresPlan": "Requires Business Starter plan",
  "dealRoom.toast.dealUpdated": "Deal updated",
  "dealRoom.toast.statusChanged": "Deal status changed to {status}",
  "dealRoom.toast.statusFailed": "Failed to change status",
  "dealRoom.toast.contractGenerated": "Contract draft generated successfully",
  "dealRoom.toast.contractCopied": "{language} contract copied to clipboard",
  "dealRoom.toast.messageFailed": "Failed to send message",
  "dealRoom.toast.suggestionFailed": "Failed to generate suggestion",
  "dealRoom.toast.documentUploaded": "Document uploaded",
  "dealRoom.toast.uploadFailed": "Upload failed",
  "dealRoom.toast.analysisComplete": "AI document analysis complete",
  "dealRoom.toast.analysisFailed": "AI analysis failed",
  "dealRoom.toast.documentDeleted": "Document deleted",
  "dealRoom.toast.deleteFailed": "Failed to delete document",
  "dealRoom.incomingCall.started": "{name} started a call",
  "dealRoom.incomingCall.inProgress": "Call in progress",
  "dealRoom.incomingCall.accept": "Accept",
  "dealRoom.incomingCall.decline": "Decline",
  "dealRoom.details.created": "Created",
  "dealRoom.details.addNotes": "Add deal notes...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Skip for now",
  "onboarding.badge": "AI-Powered Setup",
  "onboarding.welcome": "Welcome, {name}!",
  "onboarding.welcomeGeneric": "Welcome!",
  "onboarding.subtitle": "Let's set up your PocketFiler workspace. Tell our AI Concierge about your business, and we'll configure everything for you.",
  "onboarding.step1": "Describe your business and needs",
  "onboarding.step2": "AI suggests your setup",
  "onboarding.step3": "Start managing deals",
  "onboarding.concierge.title": "AI Concierge",
  "onboarding.toast.officeCreated": "Virtual office created!",
  "validation.nameRequired": "Name is required",
  "validation.nameTooLong": "Name must be less than 50 characters",
  "validation.emailRequired": "Email is required",
  "validation.emailInvalid": "Invalid email format",
  "validation.phoneRequired": "Phone number is required",
  "validation.phoneInvalid": "Invalid phone number (10-15 digits)",
  "validation.noteTooLong": "Note must be less than 200 characters",
  "common.deleteConfirmTitle": "Are you absolutely sure?",
  "common.deleteConfirmDesc": "This action cannot be undone. This will permanently delete the item and remove data from our servers.",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "dashboard.actions.addClient": "Add Client",
  "dashboard.actions.all": "All",
  "dashboard.actions.createContract": "Create Contract",
  "dashboard.actions.createInvoice": "Create Invoice",
  "dashboard.actions.customize": "Customize",
  "dashboard.actions.newDeal": "New Deal",
  "dashboard.actions.scheduleMeeting": "Schedule Meeting",
  "dashboard.actions.uploadDocument": "Upload Document",
  "dashboard.actions.viewAll": "View All",
  "dashboard.briefing.default": "Nothing urgent right now. Your workspace is in good shape.",
  "dashboard.briefing.title": "Daily Briefing",
  "dashboard.empty.activity": "No recent activity.",
  "dashboard.empty.deals": "No deals yet. Create your first deal to see the pipeline.",
  "dashboard.empty.documents": "All documents are up to date.",
  "dashboard.empty.meetings": "No upcoming meetings.",
  "dashboard.empty.tasks": "No open tasks.",
  "dashboard.greeting.afternoon": "Good afternoon",
  "dashboard.greeting.evening": "Good evening",
  "dashboard.greeting.morning": "Good morning",
  "dashboard.greeting.subtitle": "Here is what is happening across your workspace.",
  "dashboard.stats.documents": "Documents",
  "dashboard.stats.invoicesDue": "Invoices Due",
  "dashboard.stats.meetingsComing": "Meetings Coming",
  "dashboard.stats.tasksDue": "Tasks Due",
  "dashboard.stats.unreadMessages": "Unread Messages",
  "dashboard.widgets.dealPipeline": "Deal Pipeline",
  "dashboard.widgets.documentsAttention": "Documents Needing Attention",
  "dashboard.widgets.gettingStarted": "Getting Started",
  "dashboard.widgets.quickActions": "Quick Actions",
  "dashboard.widgets.recentActivity": "Recent Activity",
  "dashboard.widgets.tasks": "Tasks",
  "dashboard.widgets.upcomingMeetings": "Upcoming Meetings",
  "dashboard.steps.createDeal": "Create your first deal",
  "dashboard.steps.addClient": "Add a client",
  "dashboard.steps.uploadDocument": "Upload a document",
  "dashboard.steps.scheduleMeeting": "Schedule a meeting",
  "dashboard.steps.createInvoice": "Create an invoice",
  "dashboard.steps.addLogo": "Add your logo",
  "dashboard.steps.complete": "complete",
  "dashboard.time.overdue": "Overdue",
  "dashboard.time.today": "Today",
  "dashboard.time.tomorrow": "Tomorrow",
  "dashboard.time.noDate": "No date",
  "dashboard.docReason.sent": "Sent, awaiting response",
  "dashboard.docReason.notAnalyzed": "Not yet analyzed",
  "dashboard.docReason.draft": "Draft, not finalized",
  "dashboard.docReason.needsReview": "Needs review",
  "docViewer.notFound": "Document not found",
  "docViewer.previewUnavailable": "Preview not available for this file type",
  "docViewer.aiAnalysis": "AI Analysis",
  "docViewer.documentType": "Document Type",
  "docViewer.summary": "Summary",
  "docViewer.extractedFields": "Extracted Fields",
  "docViewer.issues": "Issues",
  "docViewer.tags": "Tags",
  "docViewer.noPreviousVersions": "No previous versions",
  "docViewer.noActivity": "No activity yet",
  "auth.forgotPassword.title": "Reset your password",
  "guestSign.loading": "Loading contract...",
  "guestSign.unableToLoad": "Unable to Load Contract",
  "guestSign.signed": "Contract Signed",
  "guestSign.createOwn": "Want to create and manage your own contracts?",
  "guestSign.secureSign": "Secure signing",
  "meeting.ended": "This meeting has ended",
  "meeting.cancelled": "Meeting Cancelled",
  "meeting.notFound": "Meeting Not Found",
  "meeting.joiningAs": "Joining as",
  "meeting.yourName": "Your Name *",
  "meeting.emailOptional": "Email (optional)",
  "notFound.title": "Page not found",
  "notFound.dashboard": "Go to Dashboard",
  "notFound.home": "Home",
  "auth.resetPassword.invalidLink": "Invalid link",
  "auth.resetPassword.title": "Set new password",
  "templates.category": "Category",
  "templates.legal": "Legal",
  "templates.sales": "Sales",
  "templates.services": "Services",
  "templates.finance": "Finance",
  "templates.library": "Template Library",
  "templates.libraryDesc": "Ready-to-use document templates for your business",
  "templates.noDefault": "No default templates match your search.",
  "templates.noCustom": "No custom templates found",
  "templates.delete": "Delete Template",
  "templates.cancel": "Cancel",
  "uploadRequest.notFound": "Request Not Found",
  "uploadRequest.error": "Something went wrong",
  "uploadRequest.errorDesc": "Please try again later or contact the person who sent this request.",
  "uploadRequest.uploaded": "Documents Uploaded!",
  "uploadRequest.title": "Document Upload Request",
  "uploadRequest.fileTypes": "PDF, images, Word docs — max 25MB",
  "verify.verifying": "Verifying your email...",
  "verify.success": "Email Verified!",
  "verify.signIn": "Sign In",
  "verify.alreadyVerified": "Already Verified",
  "verify.invalidLink": "Invalid Link",
  "verify.backToLogin": "Back to Login",
  "documents.documents": "Documents",
  "documents.allStatus": "All Status",
  "documents.newFolder": "New Folder",
  "documents.clear": "Clear",
  "documents.noDocumentsYet": "No documents yet",
  "documents.status": "Status",
  "documents.type": "Type",
  "documents.uploadedBy": "Uploaded by",
  "documents.previewNotAvailable": "Preview not available",
  "documents.aiAnalysis": "AI Analysis",
  "documents.documentType": "Document Type",
  "documents.summary": "Summary",
  "documents.extractedFields": "Extracted Fields",
  "documents.issues": "Issues",
  "documents.notYetAnalyzed": "Not yet analyzed",
  "documents.details": "Details",
  "documents.size": "Size",
  "documents.date": "Date",
  "documents.mimeType": "MIME Type",
  "documents.noTags": "No tags",
  "documents.changeStatus": "Change Status",
  "documents.versionHistory": "Version History",
  "documents.noPreviousVersions": "No previous versions",
  "documents.activityLog": "Activity Log",
  "documents.noActivityRecordedYet": "No activity recorded yet",
  "documents.uploadDocuments": "Upload Documents",
  "documents.dragAndDropFiles": "Drag and drop files or click to browse. PDF, images, Word documents supported.",
  "documents.shareDocument": "Share Document",
  "documents.done": "Done",
  "documents.emailOptional": "Email (optional)",
  "documents.leaveEmptyToJust": "Leave empty to just generate a link",
  "documents.messageOptional": "Message (optional)",
  "documents.cancel": "Cancel",
  "documents.requestDocuments": "Request Documents",
  "documents.sendASecureUpload": "Send a secure upload link to a client via email.",
  "documents.clientEmail": "Client Email *",
  "documents.clientName": "Client Name",
  "documents.requestedDocuments": "Requested Documents *",
  "documents.renameFolder": "Rename Folder",
  "documents.selectADestinationFolder": "Select a destination folder.",
  "documents.deleteDocument": "Delete document?",
  "settings.individual": "Individual",
  "settings.business": "Business",
  "settings.buyer": "Buyer",
  "settings.seller": "Seller",
  "settings.chooseYourPreferredTheme": "Choose your preferred theme",
  "settings.light": "Light",
  "settings.dark": "Dark",
  "settings.system": "System",
  "settings.manufacturing": "Manufacturing",
  "settings.insurance": "Insurance",
  "settings.realEstate": "Real Estate",
  "settings.automotive": "Automotive",
  "settings.importexport": "Import/Export",
  "settings.other": "Other",
  "settings.brandingWhitelabel": "Branding & White-Label",
  "settings.customizeThePocketfilerExperience": "Customize the PocketFiler experience for your clients.",
  "settings.organizationLogo": "Organization Logo",
  "settings.provideADirectLink": "Provide a direct link to your transparent PNG or SVG logo.",
  "settings.primaryThemeColor": "Primary Theme Color",
  "settings.selectAHexColor": "Select a hex color code to represent your brand's primary accents.",
  "settings.accentHoverColor": "Accent / Hover Color",
  "settings.selectAHexColor1": "Select a hex color for hover states, highlights, and accent elements.",
  "settings.customDomain": "Custom Domain",
  "settings.ensureYouConfigureA": "Ensure you configure a CNAME record pointing to pocketfiler.com.",
  "settings.cancellationScheduled": "Cancellation scheduled",
  "settings.yourLastPaymentFailed": "Your last payment failed. Please update your payment method to keep access.",
  "settings.chooseYourPlan": "Choose Your Plan",
  "settings.monthly": "Monthly",
  "settings.save20": "Save 20%",
  "settings.current": "Current",
  "settings.popular": "Popular",
  "settings.contactSales": "Contact Sales",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Sync your PocketFiler meetings with Google Calendar",
  "settings.settingsPageErrorDebug": "Settings Page Error (debug)",
  "invoices.createInvoice": "Create Invoice",
  "invoices.createANewInvoice": "Create a new invoice for a client",
  "invoices.selectClient": "Select Client",
  "invoices.dueDate": "Due Date",
  "invoices.clientName": "Client Name",
  "invoices.clientEmail": "Client Email",
  "invoices.lineItems": "Line Items",
  "invoices.description": "Description",
  "invoices.qty": "Qty",
  "invoices.price": "Price",
  "invoices.tax": "Tax %",
  "invoices.total": "Total",
  "invoices.subtotal": "Subtotal:",
  "invoices.discount": "Discount:",
  "invoices.tax1": "Tax:",
  "invoices.total1": "Total:",
  "invoices.notesOptional": "Notes (optional)",
  "invoices.invoices": "Invoices",
  "invoices.manageAndTrackYour": "Manage and track your invoices",
  "invoices.totalInvoiced": "Total Invoiced",
  "invoices.paid": "Paid",
  "invoices.outstanding": "Outstanding",
  "invoices.totalInvoices": "Total Invoices",
  "invoices.allInvoices": "All Invoices",
  "invoices.myInvoices": "My Invoices",
  "invoices.receivedInvoices": "Received Invoices",
  "invoices.noInvoicesYet": "No invoices yet",
  "meetings.join": "Join",
  "meetings.end": "End",
  "meetings.meetingTitle": "Meeting Title",
  "meetings.date": "Date",
  "meetings.time": "Time",
  "meetings.duration": "Duration",
  "meetings.repeat": "Repeat",
  "meetings.doesNotRepeat": "Does not repeat",
  "meetings.weekly": "Weekly",
  "meetings.every2Weeks": "Every 2 weeks",
  "meetings.monthly": "Monthly",
  "meetings.invitePeopleOptional": "Invite People (optional)",
  "meetings.cancel": "Cancel",
  "meetings.meetings": "Meetings",
  "companyprofile.companyProfile": "Company Profile",
  "companyprofile.manageYourBusinessProfile": "Manage your business profile and team",
  "companyprofile.publicProfile": "Public Profile",
  "companyprofile.basicInformation": "Basic Information",
  "companyprofile.essentialDetailsAboutYour": "Essential details about your company",
  "companyprofile.companyName": "Company Name",
  "companyprofile.tagline": "Tagline",
  "companyprofile.industry": "Industry",
  "companyprofile.companyType": "Company Type",
  "companyprofile.description": "Description",
  "companyprofile.companyDetails": "Company Details",
  "companyprofile.additionalInformationAboutYour": "Additional information about your business",
  "companyprofile.yearEstablished": "Year Established",
  "companyprofile.numberOfEmployees": "Number of Employees",
  "companyprofile.certifications": "Certifications",
  "companyprofile.enterCertificationsSeparatedBy": "Enter certifications separated by commas",
  "companyprofile.languagesSpoken": "Languages Spoken",
  "companyprofile.shippingRegions": "Shipping Regions",
  "companyprofile.contactInformation": "Contact Information",
  "companyprofile.howPotentialPartnersCan": "How potential partners can reach you",
  "companyprofile.website": "Website",
  "companyprofile.email": "Email",
  "companyprofile.phone": "Phone",
  "companyprofile.country": "Country",
  "companyprofile.city": "City",
  "companyprofile.address": "Address",
  "companyprofile.teamMembers": "Team Members",
  "companyprofile.manageUsersWithinYour": "Manage users within your organization",
  "companyprofile.role": "Role",
  "companyprofile.admin": "Admin",
  "companyprofile.member": "Member",
  "companyprofile.viewer": "Viewer",
  "companyprofile.titleOptional": "Title (optional)",
  "companyprofile.name": "Name",
  "companyprofile.title": "Title",
  "companyprofile.status": "Status",
  "companyprofile.actions": "Actions",
  "companyprofile.owner": "Owner",
  "companyprofile.copyInviteLink": "Copy Invite Link",
  "companyprofile.removeMember": "Remove Member",
  "companyprofile.removeTeamMember": "Remove Team Member",
  "companyprofile.cancel": "Cancel",
  "products.productsServices": "Products & Services",
  "products.description": "Description",
  "products.pricing": "Pricing",
  "products.price": "Price",
  "products.unit": "Unit",
  "products.details": "Details",
  "products.minOrderQty": "Min Order Qty",
  "products.leadTime": "Lead Time",
  "products.category": "Category",
  "products.currency": "Currency",
  "products.leadTimeDays": "Lead Time (days)",
  "products.active": "Active",
  "products.showInCatalog": "Show in catalog",
  "products.cancel": "Cancel",
  "developersettings.reveal": "Reveal",
  "developersettings.copy": "Copy",
  "developersettings.hide": "Hide",
  "developersettings.securityWarning": "Security Warning",
  "developersettings.neverShareThisKey": "Never share this key publicly or in client-side code",
  "developersettings.anyoneWithThisKey": "Anyone with this key can read and modify your data",
  "developersettings.ifCompromisedRevokeImmediately": "If compromised, revoke immediately and generate a new key",
  "developersettings.iUnderstandAndAccept": "I understand and accept responsibility for this key's security",
  "developersettings.cancel": "Cancel",
  "developersettings.revealKey": "Reveal Key",
  "developersettings.accessDenied": "Access Denied",
  "developersettings.onlyBusinessAccountsHave": "Only business accounts have access to Developer Settings.",
  "developersettings.developerOverview": "Developer Overview",
  "developersettings.manageYourApiKeys": "Manage your API keys and Webhook endpoints for third-party integrations.",
  "developersettings.secretApiKeys": "Secret API Keys",
  "developersettings.interactiveApiDocumentationRarr": "Interactive API Documentation &rarr;",
  "developersettings.name": "Name",
  "developersettings.key": "Key",
  "developersettings.createdAt": "Created At",
  "developersettings.status": "Status",
  "developersettings.actions": "Actions",
  "developersettings.webhookEndpoints": "Webhook Endpoints",
  "developersettings.url": "URL",
  "developersettings.events": "Events",
  "developersettings.description": "Description",
  "developersettings.done": "Done",
  "developersettings.addWebhookEndpoint": "Add Webhook Endpoint",
  "developersettings.payloadUrl": "Payload URL",
  "developersettings.eventsToSend": "Events to send",
  "developersettings.sendMeEverything": "Send me everything (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Deal Status Changed (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Document Uploaded (document.uploaded)",
  "developersettings.descriptionOptional": "Description (Optional)",
  "analytics.noDataAvailableFor": "No data available for this period.",
  "analytics.noDealsFound": "No deals found.",
  "analytics.noClientDataAvailable": "No client data available for this period.",
  "analytics.client": "Client",
  "analytics.invoices": "Invoices",
  "analytics.revenue": "Revenue",
  "analytics.totalPipeline": "Total Pipeline",
  "analytics.noRecentActivityFor": "No recent activity for this period.",
  "analytics.pipelineOverview": "Pipeline Overview",
  "analytics.goToDeals": "Go to Deals",
  "analytics.analyticsDashboard": "Analytics Dashboard",
  "analytics.trackYourBusinessPerformance": "Track your business performance and insights",
  "analytics.last7Days": "Last 7 days",
  "analytics.last30Days": "Last 30 days",
  "analytics.last90Days": "Last 90 days",
  "analytics.lastYear": "Last year",
  "analytics.overview": "Overview",
  "analytics.myPerformance": "My Performance",
  "analytics.currentDealsByStatus": "Current deals by status",
  "analytics.revenueTrendsOverLast": "Revenue trends over last 6 months",
  "analytics.accountsGeneratingTheMost": "Accounts generating the most revenue",
  "analytics.currentCashFlowOverview": "Current cash flow overview",
  "analytics.latestBusinessActivitiesAnd": "Latest business activities and updates",
  "compliance.complianceCenter": "Compliance Center",
  "compliance.hsCodesTariffsSanctions": "HS codes, tariffs, sanctions screening, and export controls",
  "compliance.hsCodeClassification": "HS Code Classification",
  "compliance.productDescription": "Product Description",
  "compliance.tariffCalculator": "Tariff Calculator",
  "compliance.estimateImportDutiesBased": "Estimate import duties based on HS code and trade route.",
  "compliance.hsCode": "HS Code",
  "compliance.declaredValueUsd": "Declared Value (USD)",
  "compliance.originCountry": "Origin Country",
  "compliance.destinationCountry": "Destination Country",
  "compliance.dutyRate": "Duty Rate:",
  "compliance.totalRate": "Total Rate:",
  "compliance.estDuty": "Est. Duty:",
  "compliance.totalEstCost": "Total Est. Cost:",
  "compliance.tradeAgreements": "Trade Agreements:",
  "compliance.sanctionsScreening": "Sanctions Screening",
  "compliance.screenEntitiesAgainstOfac": "Screen entities against OFAC SDN list and country sanctions.",
  "compliance.entityName": "Entity Name",
  "compliance.type": "Type",
  "compliance.company": "Company",
  "compliance.individual": "Individual",
  "compliance.vessel": "Vessel",
  "compliance.countryOptional": "Country (optional)",
  "compliance.usSanctionedCountries": "US Sanctioned Countries",
  "compliance.exportControlCheck": "Export Control Check",
  "compliance.aipoweredEaritarClassificationGuidance": "AI-powered EAR/ITAR classification guidance. Not legal advice.",
  "compliance.producttechnologyDescription": "Product/Technology Description",
  "compliance.hsCodeOptional": "HS Code (optional)",
  "compliance.endUseOptional": "End Use (optional)",
  "compliance.licenseRequired": "License Required",
  "compliance.recommendations": "Recommendations:",
  "compliance.complianceHistory": "Compliance History",
  "compliance.recentComplianceChecksFor": "Recent compliance checks for your organization.",
  "compliance.noComplianceChecksYet": "No compliance checks yet. Run your first check above.",
  "intelligence.marketIntelligence": "Market Intelligence",
  "intelligence.anonymizedTradeDataAnd": "Anonymized trade data and benchmarks from the PocketFiler platform",
  "intelligence.demandByCategory": "Demand by Category",
  "intelligence.whatBuyersAreSourcing": "What buyers are sourcing on the platform (last 90 days)",
  "intelligence.noDemandDataYet": "No demand data yet. Data populates as RFQs are created on the platform.",
  "intelligence.byIndustry": "By Industry",
  "intelligence.noSupplierDataYet": "No supplier data yet.",
  "intelligence.byCountry": "By Country",
  "intelligence.byType": "By Type",
  "intelligence.byVerification": "By Verification",
  "intelligence.noDataYet": "No data yet.",
  "intelligence.yourPerformanceVsPlatform": "Your Performance vs Platform",
  "intelligence.seeHowYouStack": "See how you stack up against platform averages",
  "intelligence.completeSomeDealsTo": "Complete some deals to see benchmarks.",
  "virtualoffices.virtualOffices": "Virtual Offices",
  "virtualoffices.manageYourBrandedWorkspaces": "Manage your branded workspaces",
  "virtualoffices.officeName": "Office Name",
  "virtualoffices.industry": "Industry",
  "virtualoffices.languagesServed": "Languages Served",
  "virtualoffices.descriptionOptional": "Description (optional)",
  "virtualoffices.documentChecklist": "Document Checklist",
  "virtualoffices.languages": "Languages",
  "tasks.tasks": "Tasks",
  "tasks.noTasksYet": "No tasks yet",
  "tasks.dragTasksHere": "Drag tasks here",
  "tasks.createNewTask": "Create New Task",
  "tasks.descriptionOptional": "Description (Optional)",
  "tasks.relatedDealOptional": "Related Deal (Optional)",
  "tasks.noDealAttached": "No deal attached",
  "tasks.assignees": "Assignees",
  "tasks.noTeamMembersAvailable": "No team members available. Only active members can be assigned.",
  "tasks.cancel": "Cancel",
  "tasks.description": "Description",
  "tasks.status": "Status",
  "tasks.relatedDeal": "Related deal",
  "tasks.noAssignees": "No assignees",
  "tasks.areYouAbsolutelySure": "Are you absolutely sure?",
  "events.events": "Events",
  "events.tradeShowsWebinarsAnd": "Trade shows, webinars, and networking events",
  "events.createEvent": "Create Event",
  "events.title": "Title",
  "events.description": "Description",
  "events.category": "Category",
  "events.type": "Type",
  "events.locationUrl": "Location / URL",
  "events.startDateTime": "Start Date & Time",
  "events.endDateTime": "End Date & Time",
  "events.maxAttendeesOptional": "Max Attendees (optional)",
  "events.cancel": "Cancel",
  "events.allCategories": "All Categories",
  "events.noEventsFoundCreate": "No events found. Create the first one!",
  "events.featured": "Featured",
  "events.previous": "Previous",
  "events.next": "Next",
  "status.pendingDocuments": "Pending Documents",
  "status.pendingSignature": "Pending Signature",
  "status.pendingPayment": "Pending Payment",
  "status.completed": "Completed",
  "status.updated": "Updated",
  "status.onHold": "On Hold",
  "activity.deal": "Deal",
  "activity.action.analyzed": "Analyzed",
  "activity.action.uploaded": "Uploaded",
  "activity.action.downloaded": "Downloaded",
  "activity.action.previewed": "Previewed",
  "activity.action.shared": "Shared",
  "activity.action.status_changed": "Status changed",
  "activity.action.updated": "Updated",
  "activity.action.created": "Created",
  "activity.action.archived": "Archived",
  "activity.action.restored": "Restored",
  "deals.filter.drafts": "Drafts",
  "deals.filter.pendingSignature": "Pending Signature",
  "deals.filter.signed": "Signed",
  "analytics.totalRevenue": "Total Revenue",
  "analytics.totalDeals": "Total Deals",
  "analytics.conversionRate": "Conversion Rate",
  "analytics.avgDealValue": "Avg Deal Value",
  "analytics.dealPipeline": "Deal Pipeline",
  "analytics.monthlyRevenue": "Monthly Revenue",
  "analytics.topClientsByRevenue": "Top Clients by Revenue",
  "analytics.invoiceHealth": "Invoice Health",
  "analytics.paid": "Paid",
  "analytics.pendingPayment": "Pending Payment",
  "companyprofile.saveProfile": "Save Profile",
  "companyprofile.makeVisible": "Make your company visible in the directory",
  "companyprofile.tab.basicInfo": "Basic Info",
  "companyprofile.tab.details": "Details",
  "companyprofile.tab.contact": "Contact",
  "companyprofile.tab.team": "Team",
  "companyprofile.tab.verification": "Verification",
  "companyprofile.selectType": "Select type",
  "companyprofile.describePlaceholder": "Describe your company, products, and services...",
  "companyprofile.industry.other": "Other",
  "companyprofile.preview": "Preview",
  "companyprofile.ph.companyName": "Your Company Inc.",
  "companyprofile.ph.tagline": "Quality products, global reach",
  "companyprofile.ph.selectIndustry": "Select industry",
  "companyprofile.ph.selectSize": "Select size",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (comma separated)",
  "companyprofile.ph.languages": "English, Spanish, Chinese",
  "companyprofile.ph.exportRegions": "North America, Europe, Asia",
  "companyprofile.ph.selectCountry": "Select country",
  "companyprofile.ph.city": "Los Angeles",
  "companyprofile.ph.teamName": "Team member's name",
  "companyprofile.ph.addTitle": "Add title...",
  "companyprofile.inviteTeamMember": "Invite Team Member",
  "companyprofile.invitationSent": "Invitation Sent Successfully",
  "virtualoffices.newOffice": "New Office",
  "virtualoffices.createOffice": "Create Virtual Office",
  "virtualoffices.reviewChecklist": "Review Document Checklist",
  "virtualoffices.setupDesc": "Set up a new branded workspace for your business",
  "virtualoffices.customizeDesc": "Customize the documents you need from clients",
  "virtualoffices.ph.officeName": "e.g., Garcia Insurance - Auto Policies",
  "virtualoffices.ph.description": "Describe your office focus...",
  "virtualoffices.ph.addDocument": "Add custom document...",
  "virtualoffices.generating": "Generating...",
  "virtualoffices.aiChecklist": "AI-generated checklist for",
  "virtualoffices.clients": "Clients",
  "virtualoffices.pending": "Pending",
  "virtualoffices.invite": "Invite",
  "virtualoffices.ind.manufacturing": "Manufacturing",
  "virtualoffices.ind.insurance": "Insurance",
  "virtualoffices.ind.real_estate": "Real Estate",
  "virtualoffices.ind.automotive": "Automotive",
  "virtualoffices.ind.import_export": "Import/Export",
  "virtualoffices.ind.other": "Other",
  "messages.conversations": "Conversations",
  "messages.searchPlaceholder": "Search messages...",
  "messages.noConversations": "No conversations",
  "messages.send": "Send",
  "messages.selectConversation": "Select a Conversation",
  "messages.selectConversationDesc": "Choose a conversation from the sidebar to start chatting",
  "messages.support": "Support",
  "messages.client": "Client",
  "messages.deal": "Deal",
  "meetings.subtitle": "Schedule and manage video meetings",
  "meetings.upcoming": "Upcoming",
  "meetings.past": "Past",
  "meetings.schedule": "Schedule",
  "meetings.startInstant": "Start Instant",
  "meetings.startNow": "Start Now",
  "meetings.noPast": "No past meetings",
  "meetings.noUpcoming": "No upcoming meetings",
  "meetings.createMeeting": "Create Meeting",
  "meetings.startInstantMeeting": "Start Instant Meeting",
  "meetings.scheduleMeeting": "Schedule Meeting",
  "meetings.scheduleDesc": "Schedule a video meeting and send invites.",
  "meetings.invitePeople": "Invite People (optional)",
  "meetings.15min": "15 minutes",
  "meetings.30min": "30 minutes",
  "meetings.45min": "45 minutes",
  "meetings.allowRecording": "Allow recording",
  "meetings.recordingDesc": "Enables the host to record this meeting",
  "meetings.waitingRoom": "Waiting Room",
  "meetings.waitingRoomDesc": "Participants must be admitted by the host before joining",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "Cancel this meeting?",
  "meetings.cancelMeeting": "Cancel meeting",
  "documents.title": "Documents",
  "documents.viewAll": "View All",
  "documents.archived": "Archived",
  "documents.requestDocs": "Request Docs",
  "documents.upload": "Upload",
  "documents.allDocuments": "All Documents",
  "documents.searchPlaceholder": "Search documents...",
  "documents.addTag": "Add tag...",
  "documents.uploadDesc": "Drag and drop files or click to browse. PDF, images, Word documents supported.",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "Here's the document you requested...",
  "documents.requestDesc": "Send a secure upload link to a client via email.",
  "documents.namePlaceholder": "John Doe",
  "documents.requestMsgPlaceholder": "Please upload the following documents...",
  "documents.folderName": "Folder name",
  "documents.selectDestination": "Select a destination folder.",
  "documents.statusUploaded": "Uploaded",
  "documents.statusAnalyzed": "Analyzed",
  "documents.statusArchived": "Archived",
  "documents.allTypes": "All Types",
  "documents.inArchive": "in archive",
  "templates.allTemplates": "All Templates",
  "templates.editTemplate": "Edit Template",
  "templates.createCustomTemplate": "Create Custom Template",
  "templates.editDesc": "Update your document template",
  "templates.createDesc": "Create your own reusable document template",
  "templates.ph.templateName": "e.g., Custom NDA",
  "templates.ph.description": "Brief description of the template",
  "templates.ph.content": "Enter your template content here...",
  "templates.saving": "Saving...",
  "templates.creating": "Creating...",
  "templates.saveChanges": "Save Changes",
  "templates.createTemplate": "Create Template",
  "templates.searchPlaceholder": "Search templates...",
  "templates.popularTemplates": "Popular Templates",
  "templates.defaultTemplates": "Default Templates",
  "templates.deleteTemplate": "Delete Template",
  "templates.preview": "Preview",
  "templates.description": "Description",
  "products.searchPlaceholder": "Search products...",
  "products.ph.service": "Consulting Services",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Select category",
  "products.ph.describe": "Describe your product or service...",
  "products.noMatches": "No matches found",
  "products.noProducts": "No products or services yet",
  "products.serviceDetails": "Service details",
  "products.productDetails": "Product details",
  "products.inactive": "Inactive",
  "products.deleteConfirm": "Delete this item?",
  "products.saveChanges": "Save Changes",
  "products.addItem": "Add Item",
  "products.priceOnRequest": "Price on request",
  "products.perUnit": "Per Unit",
  "tasks.searchPlaceholder": "Search tasks...",
  "tasks.ph.title": "e.g. Review legal documents",
  "tasks.ph.description": "Add more context to this task...",
  "tasks.selectDeal": "Select a deal to attach",
  "tasks.noTasks": "No tasks in this column",
  "tasks.deleteTask": "Delete Task",
  "settings.tabs.branding": "Branding",
  "settings.tabs.payments": "Payments",
  "settings.tabs.plan": "Plan",
  "settings.tabs.integrations": "Integrations",
  "settings.appearance": "Appearance",
  "settings.saveBranding": "Save Branding",
  "settings.yourPlan": "Your Plan",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "Calendar feed URL generated!",
  "settings.plan.free": "Free",
  "settings.plan.pro": "Pro",
  "settings.plan.smallBusiness": "Small Business",
  "settings.plan.businessPro": "Business Pro",
  "settings.plan.scale": "Scale",
  "settings.plan.enterprise": "Enterprise",
  "dealroom.meetings": "Meetings",
  "dealroom.startMeeting": "Start Meeting",
  "dealroom.noMeetings": "No meetings linked to this deal yet",
  "dealroom.noMeetingsDesc": "Start a meeting or schedule one to get started",
  "dealroom.failedCreateMeeting": "Failed to create meeting",
  "dealroom.finalizedContract": "Finalized Contract — Ready for Signature",
  "dealroom.previewNotSupported": "Preview not supported",
  "dealroom.aiMayTakeMoment": "This may take a moment.",
  "dealroom.aiAnalysisGenerated": "AI analysis has been generated for the following documents:",
  "dealroom.docsUnanalyzed": "The following documents remain unanalyzed:",
  "dealroom.analyzingDocs": "Analyzing documents...",
  "dealroom.finalizeWarning": "This action cannot be undone. The deal status will change to Pending Signature and all parties will be able to sign the contract.",
  "dealroom.cannotRevert": "Cannot revert from Pending Signature",
  "compliance.ph.productDesc": "e.g., Stainless steel bolts, M10 x 50mm...",
  "compliance.ph.exportDesc": "Describe the product or technology being exported...",
  "compliance.select": "Select...",
  "compliance.selectCountry": "Select country...",
  "events.tradeShow": "Trade Show",
  "events.webinar": "Webinar",
  "events.networking": "Networking",
  "events.conference": "Conference",
  "events.workshop": "Workshop",
  "events.ph.title": "Event title",
  "events.ph.location": "Venue address or meeting URL",
  "events.ph.maxAttendees": "Leave empty for unlimited",
  "events.searchPlaceholder": "Search events...",
  "events.cancelRsvp": "Cancel RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Expired",
  "rfq.createRfq": "Create Request for Quote",
  "rfq.visibility": "Visibility",
  "rfq.public": "Public - All suppliers can see",
  "rfq.private": "Private - Invite only",
  "rfq.quantity": "Quantity",
  "rfq.unit": "Unit",
  "rfq.pieces": "Pieces",
  "rfq.kilograms": "Kilograms",
  "rfq.meters": "Meters",
  "rfq.squareMeters": "Square Meters",
  "rfq.units": "Units",
  "rfq.sets": "Sets",
  "rfq.boxes": "Boxes",
  "rfq.deliveryLocation": "Delivery Location",
  "rfq.deliveryDeadline": "Delivery Deadline",
  "rfq.specialRequirements": "Special Requirements",
  "rfq.title": "Request for Quotes",
  "rfq.subtitle": "Browse sourcing requests or post your own",
  "rfq.rfqsPosted": "RFQs Posted",
  "rfq.openRfqs": "Open RFQs",
  "rfq.quotesSent": "Quotes Sent",
  "rfq.winRate": "Win Rate",
  "rfq.allCategories": "All Categories",
  "rfq.noRfqsFound": "No RFQs found",
  "rfq.noRfqsYet": "No RFQs yet",
  "meetings.biweekly": "Every 2 weeks",
  "meetings.cancelSeries": "Cancel entire series",
  "meetings.cancelThisMeeting": "Cancel this meeting",
  "meetings.nextInSeries": "Next in series",
  "nav.contractTemplates": "Contracts",
  "contracts.title": "Contract Templates",
  "contracts.subtitle": "AI-powered legal document generation. Select a template to get started.",
  "documents.create": "Create",
  "createDoc.untitledDocument": "Untitled Document",
  "createDoc.save": "Save",
  "createDoc.export": "Export",
  "createDoc.aiAssist": "AI Assist",
  "createDoc.aiAssistTitle": "AI Writing Assistant",
  "createDoc.aiPromptLabel": "What would you like AI to write?",
  "createDoc.aiPromptPlaceholder": "e.g., Write an introduction paragraph for a service agreement between...",
  "createDoc.aiPromptHint": "AI will generate content and insert it at your cursor position.",
  "createDoc.generate": "Generate",
  "createDoc.generating": "Generating...",
  "createDoc.cancel": "Cancel",
  "createDoc.insert": "Insert",
  "createDoc.insertLink": "Insert Link",
  "createDoc.saved": "Document saved successfully",
  "createDoc.saveFailed": "Failed to save document",
  "createDoc.titleRequired": "Please enter a document title",
  "createDoc.contentRequired": "Document cannot be empty",
  "createDoc.aiContentInserted": "AI content inserted",
  "createDoc.aiGenerationFailed": "AI generation failed",
  "createDoc.typeGeneral": "General",
  "createDoc.typeContract": "Contract",
  "createDoc.typeInvoice": "Invoice",
  "createDoc.typeLetter": "Letter",
  "createDoc.typeReport": "Report",
  "createDoc.typeOther": "Other",
  "createDoc.translate": "Translate",
  "createDoc.translateTitle": "Translate Document",
  "createDoc.translateTo": "Translate to",
  "createDoc.translateHint": "This will replace the current document content with the translated version. Use Ctrl+Z to undo.",
  "createDoc.translateNow": "Translate",
  "createDoc.translating": "Translating...",
  "createDoc.translated": "Document translated successfully",
  "createDoc.translateFailed": "Translation failed",
  "verification.status": "Verification Status",
  "verification.inProgress": "Verification In Progress",
  "verification.reviewTime": "Your request is being reviewed. This typically takes 1-2 business days.",
  "verification.getVerified": "Get Verified",
  "verification.cancelRequest": "Cancel Request",
  "verification.submit": "Submit for Verification",
  "verification.submitting": "Submitting...",
  "verification.additionalNotes": "Additional Notes (optional)",
  "verification.uploadDocs": "Upload Documents",
  "verification.level": "Verification Level",
  "verification.selectDocType": "Select document type...",
  "contracts.generate": "Generate",
  "contracts.backToTemplates": "Back to templates",
  "contracts.required": "Required",
  "contracts.modify": "Modify",
  "contracts.finalize": "Finalize",
  "contracts.modifyPrompt": "Tell AI how to modify this document:",
  "contracts.applyChanges": "Apply Changes",
  "contracts.confirmDelete": "Delete this draft?",
  "contracts.loadFailed": "Failed to load templates",
  "contracts.detailsFailed": "Failed to load template details",
  "contracts.generationFailed": "Generation failed",
  "contracts.generating": "Generating document...",
  "contracts.planInfo": "drafts/month",
  "contracts.nda": "Mutual Non-Disclosure Agreement",
  "contracts.ndaOneway": "One-Way Non-Disclosure Agreement",
  "contracts.sow": "Statement of Work",
  "contracts.msa": "Master Services Agreement",
  "contracts.contractor": "Independent Contractor Agreement",
  "contracts.loi": "Letter of Intent",
  "templates.deleting": "Deleting...",
  "templates.noDescription": "No description provided.",
  "templates.use": "Use",
  "templates.confirmDeleteDesc": "This will permanently delete this template. This action cannot be undone.",
  "templates.lib.ndaMutual": "Mutual NDA",
  "templates.lib.ndaMutualDesc": "Standard mutual non-disclosure agreement for protecting confidential information between two parties.",
  "templates.lib.purchaseAgreement": "Purchase Agreement",
  "templates.lib.purchaseAgreementDesc": "Standard purchase agreement template for B2B product sales with terms and conditions.",
  "templates.lib.serviceAgreement": "Service Agreement",
  "templates.lib.serviceAgreementDesc": "Professional services agreement template with scope of work and deliverables.",
  "templates.lib.priceQuote": "Price Quote",
  "templates.lib.priceQuoteDesc": "Professional quotation template for providing pricing to potential customers.",
  "templates.lib.invoice": "Invoice",
  "templates.lib.invoiceDesc": "Professional invoice template for billing clients and tracking payments.",
  "templates.lib.loi": "Letter of Intent",
  "templates.lib.loiDesc": "Letter of intent template for expressing interest in a potential business arrangement.",
  "settings.security": "Security",
  "security.twoFactor": "Two-Factor Authentication",
  "security.twoFactorDesc": "Add an extra layer of security to your account with TOTP-based verification.",
  "security.enabled": "Enabled",
  "security.disabled": "Disabled",
  "security.2faActiveDesc": "Your account is protected with two-factor authentication",
  "security.2faInactiveDesc": "Enable 2FA to protect your account",
  "security.enable2FA": "Enable 2FA",
  "security.disable": "Disable",
  "security.activeSessions": "Active Sessions",
  "security.activeSessionsDesc": "Devices currently logged into your account.",
  "security.logoutAll": "Log out everywhere",
  "security.lastUsed": "Last used",
  "security.currentSession": "Current",
  "security.loginHistory": "Login History",
  "security.successfulLogin": "Successful login",
  "security.failedLogin": "Failed login attempt",
  "security.setup2FA": "Set Up Two-Factor Authentication",
  "security.scanQR": "Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.), or enter the secret key manually.",
  "security.secretKey": "Secret Key (manual entry)",
  "security.enterCode": "Enter the 6-digit code from your app",
  "security.verify": "Verify & Enable",
  "security.cancel": "Cancel",
  "security.saveBackupCodes": "Save Your Backup Codes",
  "security.backupCodesDesc": "Save these codes somewhere safe. Each code can only be used once.",
  "security.copyAll": "Copy All",
  "security.done": "Done",
  "security.disable2FA": "Disable Two-Factor Authentication",
  "security.disable2FADesc": "Enter your password to confirm.",
  "security.password": "Password",
  "security.confirmDisable": "Disable 2FA",
  "security.2faEnabled": "2FA enabled successfully!",
  "security.2faDisabled": "2FA disabled",
  "security.sessionRevoked": "Session revoked",
  "security.allSessionsRevoked": "All sessions revoked",
  "feedback.button": "Feedback",
  "feedback.title": "Send Feedback",
  "feedback.type": "Type",
  "feedback.typeBug": "Bug",
  "feedback.typeFeature": "Feature",
  "feedback.typeGeneral": "General",
  "feedback.description": "Description",
  "feedback.descPlaceholder": "Tell us what happened...",
  "feedback.priority": "Priority",
  "feedback.priorityLow": "Low",
  "feedback.priorityMedium": "Medium",
  "feedback.priorityHigh": "High",
  "feedback.submit": "Submit",
  "feedback.submitting": "Submitting...",
  "feedback.thanks": "Thanks! We\'ll look into this.",
  "feedback.autoCapture": "Page URL, browser info, and error logs are captured automatically.",
};

export default en;
